/**
 * custom pipe operators that you can import into your .ts files and use as needed
 * https://angular.io/guide/pipes
 * questions? simen@semway.no
 */

import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transform string to camelCase
 * @param string value
 * @return string
 * Usage:
 *   {{ some text | camelCase }}
 * by simen eira
 */
@Pipe({name: 'camelCase'})
export class CamelCasePipe implements PipeTransform
{

	transform(value: string): string
	{
		return (!!value) ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : '';
	}

}


/**
 * Format string as org nr
 * @param string|number value
 * @return string
 * Usage:
 *   {{ some text | orgNr }}
 * by ole fjarestad
 */
@Pipe({name: 'orgNr'})
export class OrgNrPipe implements PipeTransform
{

  transform(value: string): string
  {

	value = value.toString();
	let insertEvery = 3;
	let insert = ' ';


	for (var i = value.length-insertEvery; i > 0; i -= insertEvery)
	{

		value = value.slice( 0, i ) + insert + value.slice( i, value.length );

	}


	return value;

  }

}


/**
 * Format string as phone nr
 * @param string|number value
 * @return string
 * Usage:
 *   {{ 12345678 | orgNr }}
 * by ole fjarestad
 */
@Pipe({name: 'phone'})
export class PhonePipe implements PipeTransform
{

	transform(value: string): string
	{

		value = value.toString();
		let insert = ' ';

		return value.substr(0, 3) + insert + value.substr(3, 2) + insert + value.substr(5, value.length-5);

	}

}


// WEBPACK FOOTER //
// ./src/app/pipes.ts